module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - Abrindo chamado'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fade-transition"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Chamados")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Cadastro',
        href: '#'
      }, {
        text: 'Chamados',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content "
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "row1"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {}, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "frmCommonRegister",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "col-md-6",
    attrs: {
      "id": "chamado"
    }
  }, [_c('fieldset', [_c('legend', [_vm._v("\n                          O chamado é para um projeto específico?\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-body",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 form-group required",
    class: {
      'has-error': _vm.errors.first('projetoSN')
    }
  }, [_c('span', [_c('label', {
    staticClass: "radio-inline new-control new-control-radio",
    staticStyle: {
      "padding-top": "7px"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.projetoEspecifico),
      expression: "projetoEspecifico"
    }],
    attrs: {
      "type": "radio",
      "name": "projetoSN",
      "value": "SIM"
    },
    domProps: {
      "checked": _vm._q(_vm.projetoEspecifico, "SIM")
    },
    on: {
      "change": function($event) {
        _vm.projetoEspecifico = "SIM"
      }
    }
  }), _vm._v(" Sim "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio",
    staticStyle: {
      "padding-top": "7px"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.projetoEspecifico),
      expression: "projetoEspecifico"
    }],
    attrs: {
      "type": "radio",
      "name": "projetoSN",
      "value": "NAO"
    },
    domProps: {
      "checked": _vm._q(_vm.projetoEspecifico, "NAO")
    },
    on: {
      "change": function($event) {
        _vm.projetoEspecifico = "NAO"
      }
    }
  }), _vm._v(" Não "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), (_vm.errors.first('projetoSN')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo acima deve ser marcado com Sim ou Não')))]) : _vm._e()])])])]), _vm._v(" "), (_vm.projetoEspecifico === 'SIM') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('projeto')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2 tl",
    attrs: {
      "for": "projeto"
    }
  }, [_vm._v("Projeto:")]), _vm._v(" "), (_vm.loading.projetos) ? _c('div', {
    staticClass: "col-md-10"
  }, [_vm._m(1)]) : _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.projetoEspecifico === 'SIM'
      }),
      expression: "{required: projetoEspecifico === 'SIM'}"
    }],
    attrs: {
      "options": _vm.projetos,
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": false,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": "Selecione um projeto",
      "preselect-first": false,
      "custom-label": _vm.etiquetaTipos,
      "selectLabel": "",
      "label": "Projeto",
      "track-by": "Projeto",
      "deselectLabel": "",
      "selectedLabel": "",
      "name": "projeto",
      "data-vv-as": "Projeto",
      "disabled": false
    },
    on: {
      "select": function($event) {
        return _vm.changeProjeto($event)
      }
    },
    scopedSlots: _vm._u([{
      key: "singleLabel",
      fn: function(props) {
        return [_c('div', {
          staticClass: "truncar"
        }, [_c('span', {
          staticClass: "identificadorIDProjeto"
        }, [_vm._v(_vm._s(props.option.Projeto.substr(0, 5)))]), _vm._v(_vm._s(props.option.Projeto.substring(7)))])]
      }
    }], null, false, 1733405816),
    model: {
      value: (_vm.projeto),
      callback: function($$v) {
        _vm.projeto = $$v
      },
      expression: "projeto"
    }
  }, [_c('template', {
    slot: "noOptions"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("Nenhum registro localizado!")])])], 2), _vm._v(" "), (_vm.errors.first('projeto')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Projeto deve ser selecionado')))]) : _vm._e()], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.projetoEspecifico === 'SIM' && _vm.projeto.Numero_projeto) ? _c('legend', [_vm._v("\n                          O chamado é para um ID específico?\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.projetoEspecifico === 'SIM' && _vm.projeto.Numero_projeto) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-body",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 form-group required-field",
    class: {
      'has-error': _vm.errors.first('tarefaSN')
    }
  }, [_c('span', [_c('label', {
    staticClass: "radio-inline new-control new-control-radio",
    staticStyle: {
      "padding-top": "7px"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.tarefaEspecifica),
      expression: "tarefaEspecifica"
    }],
    attrs: {
      "type": "radio",
      "name": "tarefaSN",
      "value": "SIM"
    },
    domProps: {
      "checked": _vm._q(_vm.tarefaEspecifica, "SIM")
    },
    on: {
      "change": function($event) {
        _vm.tarefaEspecifica = "SIM"
      }
    }
  }), _vm._v(" Sim "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio",
    staticStyle: {
      "padding-top": "7px"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.tarefaEspecifica),
      expression: "tarefaEspecifica"
    }],
    attrs: {
      "type": "radio",
      "name": "tarefaSN",
      "value": "NAO"
    },
    domProps: {
      "checked": _vm._q(_vm.tarefaEspecifica, "NAO")
    },
    on: {
      "change": function($event) {
        _vm.tarefaEspecifica = "NAO"
      }
    }
  }), _vm._v(" Não "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), (_vm.errors.first('tarefaSN')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo acima deve ser marcado com Sim ou Não')))]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.projetoEspecifico === 'SIM' && _vm.tarefaEspecifica === 'SIM') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('tarefa')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2 tl",
    attrs: {
      "for": "tarefa"
    }
  }, [_vm._v("ID:")]), _vm._v(" "), (_vm.loading.ids) ? _c('div', {
    staticClass: "col-md-10"
  }, [_vm._m(2)]) : _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.tarefaEspecifica === 'SIM'
      }),
      expression: "{required: tarefaEspecifica === 'SIM'}"
    }],
    attrs: {
      "options": _vm.tarefas,
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": false,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": "Selecione um ID",
      "preselect-first": false,
      "custom-label": _vm.etiquetaTarefas,
      "selectLabel": "",
      "label": "id",
      "track-by": "id",
      "deselectLabel": "",
      "selectedLabel": "",
      "name": "tarefa",
      "data-vv-as": "Tarefa",
      "disabled": false
    },
    on: {
      "select": function($event) {
        return _vm.changeTarefa($event)
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [(props.option.projeto === 'Cabeçalho de tarefas') ? _c('div', {
          staticClass: "col-md-12"
        }, [_c('div', {
          staticClass: "etiquetaTarefa"
        }, [_c('span', [_vm._v("ID")]), _c('span', [_vm._v("Tipo")]), _c('span', [_vm._v("Valor")])])]) : _c('div', {
          staticClass: "col-md-12"
        }, [_c('div', {
          staticClass: "etiquetaTarefa"
        }, [_c('span', [_c('strong', [_vm._v(_vm._s(props.option.id))])]), _c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(props.option.tipo_solicitacao))]), _c('span', [_vm._v(_vm._s(_vm._f("real")(props.option.valor)))])])])]
      }
    }, {
      key: "singleLabel",
      fn: function(props) {
        return [_c('div', {
          staticClass: "etiquetaTarefa"
        }, [_c('span', [_c('span', {
          staticClass: "identificadorIDProjeto"
        }, [_vm._v(_vm._s(props.option.id))]), _c('span', [_vm._v(_vm._s(props.option.tipo_solicitacao))])]), _c('span', [_vm._v(_vm._s(_vm._f("real")(props.option.valor)))])])]
      }
    }], null, false, 2318851965),
    model: {
      value: (_vm.tarefa),
      callback: function($$v) {
        _vm.tarefa = $$v
      },
      expression: "tarefa"
    }
  }, [_vm._v(" "), _c('template', {
    slot: "noResult"
  }, [_vm._v("Nenhum registro localizado!")]), _vm._v(" "), _c('template', {
    slot: "noOptions"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("Não há solicitações para selecionado")])])], 2), _vm._v(" "), (_vm.errors.first('tarefa')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo ID deve ser selecionado')))]) : _vm._e()], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('assunto')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2 tl",
    attrs: {
      "for": "assunto"
    }
  }, [_vm._v("Assunto:")]), _vm._v(" "), (_vm.loading.assuntos) ? _c('div', {
    staticClass: "col-md-10"
  }, [_vm._m(3)]) : _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.listaAssuntos,
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": false,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": "Selecione um assunto",
      "custom-label": _vm.etiquetaAssuntos,
      "preselect-first": false,
      "selectLabel": "",
      "label": "id",
      "track-by": "id",
      "deselectLabel": "",
      "selectedLabel": "Selecionado",
      "name": "assunto",
      "data-vv-as": "assunto",
      "disabled": false
    },
    on: {
      "select": function($event) {
        return _vm.changeAssunto($event)
      }
    },
    model: {
      value: (_vm.assunto),
      callback: function($$v) {
        _vm.assunto = $$v
      },
      expression: "assunto"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('assunto')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Assunto é obrigatório')))]) : _vm._e()], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    attrs: {
      "id": "chamado2"
    }
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('descricao')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Descrição do problema ou dúvida:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chamadoObj.descricao),
      expression: "chamadoObj.descricao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "175px",
      "resize": "none",
      "border": "1px solid #a8a3a5"
    },
    attrs: {
      "name": "descricao",
      "placeholder": _vm.place
    },
    domProps: {
      "value": (_vm.chamadoObj.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.chamadoObj, "descricao", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('descricao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Descrição é obrigatório')))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "large-12 medium-12 small-12 cell"
  }, [_vm._m(4), _vm._v(" "), _c('upload-documentos-chamado', {
    attrs: {
      "propDocumentos": _vm.chamadoObj.anexos
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "error",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'cadastro-chamado-lista'
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "success",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salvaChamado()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Enviar")])], 1)])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Abrir Chamado")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando projetos...")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando solicitações...")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando assuntos ...")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Anexo")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5bb1cf19!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/chamado/AbrirChamado.vue
// module id = 1877
// module chunks = 2